import { makePostRequest } from '@/api/fetchCalls'
import { QuestionMetricsPayload } from '@/domain/model/question_metrics'

const ANALYTICS_API_BASE = process.env.REACT_APP_ANALYTICS_API_BASE

export const addNewQuestionMetric = async (
  message_code: string,
  payload: QuestionMetricsPayload
) => {
  const isUUID = message_code.includes('-')
  if (!message_code || isUUID) {
    return Promise.resolve()
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return await makePostRequest(
    `${ANALYTICS_API_BASE}/api/v1/analytics/question-metrics/`,
    {
      body: JSON.stringify(payload),
    }
  )
}
